import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchBuchhaltung(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('buchhaltung_belege')
    .select('id, nummer, beschreibung, anbieter, betrag, datum, status, updated_at')
    .or(`nummer.ilike.${pattern},beschreibung.ilike.${pattern},anbieter.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Buchhaltung search error:', error);
    return [];
  }

  return (data || [])
    .filter(b => matchFn(term, b.nummer, b.beschreibung, b.anbieter))
    .slice(0, limit)
    .map(b => {
      const title = b.beschreibung || b.nummer || 'Beleg';
      const subtitle = b.betrag ? `€ ${b.betrag.toLocaleString('de-DE')}` : b.anbieter || undefined;
      
      return {
        id: b.id,
        type: 'buchhaltung' as SearchSectionId,
        title,
        subtitle,
        badge: b.status || 'Beleg',
        data: b,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, b.updated_at)
      };
    });
}
